import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventUser extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventUser';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            userId: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.EventGuest) {
    //         data.EventGuest = new models.api.EventGuest(data.EventGuest)
    //     }
    //     return data
    // }
}

const servicePath = 'event-users';
const servicePlugin = makeServicePlugin({
    Model: EventUser,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin